import { Box, GitCommitVertical, GitFork, GitPullRequestDraft } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * The glyph an ontology level is drawn with. The type is carried by the shape
 * alone — the views that list levels are neutral, and colour is kept for
 * publish status.
 */
export default function NodeTypeIcon({ type, isRoot = false, className }) {
    const classes = cn('size-3.5 shrink-0 text-zinc-400', className);

    if (isRoot) {
        return <Box className={classes} aria-hidden="true" />;
    }

    switch (type) {
        case 'series':
            return <GitPullRequestDraft className={classes} aria-hidden="true" />;
        case 'many':
            return <GitFork className={cn(classes, 'rotate-180')} aria-hidden="true" />;
        case 'singular':
            return <GitCommitVertical className={classes} aria-hidden="true" />;
        default:
            return <Box className={classes} aria-hidden="true" />;
    }
}

// Mirrors the element-type descriptions shown when building an ontology
// (Pages/Ontology/Show.jsx "Add a new ... Element" dialogs) so the language
// stays consistent wherever a relationship type is explained.
export function relationshipExplanation(type) {
    switch (type) {
        case 'series':
            return 'Series elements sit in parallel, next to each other — think Batches or Units.';
        case 'many':
            return 'Many elements act as a collection under their parent — think Cells in a Battery Pack.';
        case 'singular':
            return 'Singular elements are individual instances, inherited by everything beneath them — think a Display under a Unit.';
        default:
            return 'This level is part of the passport hierarchy.';
    }
}
